export default [
  {
    path: '/teste-qtd-mat-serv',
    component: () => import('@/views/Index'),
    children: [
      {
        name: 'QTD Materal x Serviços Histórico',
        path: 'historico',
        component: () => import('@/views/testeQtdMatServ/Historico.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [{ name: 'Power Ups', path: '/powerups' }, { name: 'QTD Materal x Serviços' }]
        }
      },
      {
        name: 'QTD Materal x Serviços Adicionar',
        path: 'edit',
        component: () => import('@/views/testeQtdMatServ/Edit.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            { name: 'Power Ups', path: '/powerups' },
            { name: 'QTD Materal x Serviços', path: '/teste-qtd-mat-serv/historico' },
            { name: 'Adicionar' }
          ]
        }
      },
      {
        name: 'QTD Materal x Serviços Editar',
        path: 'edit/:id',
        component: () => import('@/views/testeQtdMatServ/Edit.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            { name: 'Power Ups', path: '/powerups' },
            { name: 'QTD Materal x Serviços', path: '/teste-qtd-mat-serv/historico' },
            { name: 'Editar' }
          ]
        }
      }
    ]
  }
];
